export default {
  silver: 'linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%)',
} as const
